import React, { useContext } from "react";
import { useNavigate, Link } from "react-router-dom";
import { FiArrowRight } from "react-icons/fi";
import { Language } from "../../App";

export default function SearchResultCard({
  title,
  icon,
  count,
  children,
  link,
  seeAll,
  id,
  className = "",
  showHeader = true,
}) {
  const navigate = useNavigate();
  const { lang } = useContext(Language);

  const elementId = id || (typeof title === "string" ? title.toLowerCase().replace(/\s+/g, "-") : undefined);

  return (
    <div id={elementId} className={`search-section-card ${className}`}>
      {showHeader && (
        <div className="search-section-header">
          <div className="search-section-header-left">
            {icon && <div className="search-section-icon-badge">{icon}</div>}
            <h2 className="search-section-title">{title}</h2>
            {typeof count === "number" && count > 0 && (
              <span className="search-section-count-badge">{count}</span>
            )}
          </div>

          {seeAll && link && (
            <Link
              to={link}
              className="search-see-all-btn"
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            >
              <span>{lang?.see_all_results || "See All"}</span>
              <FiArrowRight size={14} />
            </Link>
          )}
        </div>
      )}

      <div className="search-section-body">
        {children}
      </div>
    </div>
  );
}
